
export const CurrencyFormatter = new Intl.NumberFormat('en-NZ', {
  style: 'currency',
  currency: 'NZD',
}).format;



Date.prototype.toDateInputValue = (function () {
    var local = new Date(this);
    local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
    return local.toJSON().slice(0, 10);
});


export const imageUrl = (imageObj, size="medium") => {

    if (!imageObj) return ""
    if(imageObj.length == 0) return "/resources/images/content/default-image-3.png"
    const base = "/resources/images/content/";
    let chosen;

    //get size requested, otherwise return largest size present
    if (imageObj[size]){
        chosen = imageObj[size]
    }else if(size == 'thumbnail' && imageObj.small){
        chosen = imageObj["small"];
    }else if(size == 'original' && imageObj.original){
        chosen = imageObj["original"]
    } else if (imageObj.large){
        chosen = imageObj["large"]
    }else if(imageObj.medium){
        chosen = imageObj["medium"]
    }else if(imageObj.small){
        chosen = imageObj["small"]
    }else if(imageObj.filename){
        chosen = imageObj
    }else{
        return ""
    }

    let filename = chosen.filename

    return base + filename;
}

//convert date from "yyyy-mm-dd hh:mm:ss" to "yyyy-mm-dd"
export const convertDate = (dateAndTime) => {
    if (!dateAndTime) return
    return new Date(dateAndTime.replace(/-/g, "/")).toDateInputValue();
    // return dateAndTime.split(" ")[0].split("-").join("/")

}

//convert yyyy-mm-dd
export const unconvertDate = (date) => {
    if (!date) return
    // console.log(date)
    const changed = date.split("/").join("-") + " 00:00:00"
    // console.log(changed)
    return changed
}


export const isInViewport = (elem) => {
    const bounding = elem.getBoundingClientRect();
    return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};


export const filterObject = (object, predicate) => {
    const result = {};

    for (const [key, value] of Object.entries(object)) {
        if (predicate(value)) {
            result[key] = value;
        }
    }

    return result;
};

export const titleCase = (str) => {
    let strSplit = str.split(" ");
    let newStr = []
    for(let word of strSplit) {
        newStr.push(word.charAt(0).toUpperCase() + word.substring(1).toLowerCase());
    }
    return newStr.join(" ");
}